export default __webpack_public_path__ + "static/smartTechnologiesLogo-bb3fc936205497fe9d05ac53d9d95e34.png";